import React from 'react';
import WebServices from '../components/WebServices';

const ServicesPage = () => {
    return (
        <div className="services-page reveal-fade">
            <WebServices />
        </div>
    );
};

export default ServicesPage;
